/* global SERVER_BASE_URL */
import {
  VERIFY_EMAIL_REQUEST,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILURE,
  REISSUE_TOKEN_REQUEST,
  REISSUE_TOKEN_SUCCESS,
  REISSUE_TOKEN_FAILURE,
} from '../constants/actionTypes'

import fetch from 'isomorphic-fetch'

import processError from '../helpers/processError'

function emailVerificationRequest(token) {
  return {
    type: VERIFY_EMAIL_REQUEST,
    isVerifying: true,
    token,
  }
}

function emailVerificationSuccess() {
  return {
    type: VERIFY_EMAIL_SUCCESS,
    isVerifying: false,
  }
}

function emailVerificationFailure(message) {
  return {
    type: VERIFY_EMAIL_FAILURE,
    isVerifying: false,
    message,
  }
}

export function verifyEmail(token) {
  const url = `${SERVER_BASE_URL}/api/users/verify-email/${token}`
  const config = {
    method: 'POST',
    accept: 'application/json',
  }
  return (dispatch) => {
    dispatch(emailVerificationRequest(token))
    return fetch(url, config)
      .then(response => {
        response.json()
          .then(res => ({ res, response }))
          .then(({ res, response }) => {
            if (!response.ok) {
              dispatch(emailVerificationFailure(processError(res)))
              return Promise.reject(res)
            } else {
              dispatch(emailVerificationSuccess())
            }
          }).catch(err => {
            console.log(err)
          })
      })
  }
}

function reissueTokenRequest(email) {
  return {
    type: REISSUE_TOKEN_REQUEST,
    isReissuing: true,
    email,
  }
}

function reissueTokenSuccess() {
  return {
    type: REISSUE_TOKEN_SUCCESS,
    isReissuing: false,
  }
}

function reissueTokenFailure(message) {
  return {
    type: REISSUE_TOKEN_FAILURE,
    isReissuing: false,
    message,
  }
}

export function reissueToken(email) {
  const url = `${SERVER_BASE_URL}/api/users/verify-email?email=${encodeURIComponent(email)}`
  const config = {
    method: 'POST',
    accept: 'application/json',
  }
  return (dispatch) => {
    dispatch(reissueTokenRequest(email))
    return fetch(url, config)
      .then(response => {
        response.json()
          .then(res => ({ res, response }))
          .then(({ res, response }) => {
            if (!response.ok) {
              dispatch(reissueTokenFailure(processError(res)))
              return Promise.reject(res)
            } else {
              dispatch(reissueTokenSuccess())
            }
          }).catch(err => {
            console.log(err)
          })
      })
  }
}
